// src/components/TopBar.js
import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export default function TopBar() {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/route.gpx'; // adjust if needed
    link.download = 'tour-de-tafel.gpx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box
      className="header-bar"
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '0.75rem 1rem',
        backgroundColor: '#f5f5f5',
        borderBottom: '1px solid #ddd',
        position: 'sticky',
        top: 0,
        zIndex: 999,
        justifyContent: 'space-between'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <img src="/logo512.png" alt="Logo" className="header-logo" style={{ height: 40, width: 40, marginRight: 12 }} />
        <Typography variant="h6" sx={{ color: '#333', margin: 0 }}>
          Tour de Tafel
        </Typography>
      </Box>

      <Button variant="outlined" onClick={handleDownload}>
        Download GPX
      </Button>
    </Box>
  );
}
